
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M41.333 0H22.666c-5.146 0-9.333 4.187-9.333 9.333v45.334c0 5.146 4.187 9.333 9.333 9.333h18.667c5.147 0 9.333-4.187 9.333-9.333V9.333C50.666 4.187 46.48 0 41.333 0zM48 54.667a6.676 6.676 0 01-6.667 6.666H22.666A6.676 6.676 0 0116 54.667V9.333a6.676 6.676 0 016.666-6.666h18.667A6.676 6.676 0 0148 9.333v45.334z","fill":"#44445E"}}),_c('path',{attrs:{"d":"M49.333 10.667H14.666a1.334 1.334 0 000 2.666h34.667a1.334 1.334 0 000-2.666zM49.333 53H14.666a1.334 1.334 0 000 2.667h34.667a1.334 1.334 0 000-2.667zM36 5.333h-8A1.334 1.334 0 0028 8h8a1.334 1.334 0 000-2.667z","fill":"#44445E"}}),_c('rect',{attrs:{"x":"37","y":"41","width":"8","height":"8","rx":"1","fill":"#FA507B"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h64v64H0z"}})])])])
          )
        }
      }
    